/**
 * Celda «Correos» de Personas (solo ADMIN): cuántos de los cuatro avisos tiene encendidos («3 de 4»)
 * y el botón que abre `DialogoCorreosPersona`. `propios` no cuenta: no es un tipo de aviso.
 *
 * Los avisos llegan de una sola petición para toda la tabla (`useAvisosDePersonas` en la página).
 */
import { TIPOS_AVISO, avisosEncendidos, type AvisosCorreo } from '@cdtec-backlog/contrato';
import './ResumenCorreos.css';

export function ResumenCorreos({
  avisos,
  sinDatos = false,
  nombre,
  onEditar,
}: {
  /** `undefined` mientras carga. */
  avisos: AvisosCorreo | undefined;
  /** La lista no se pudo cargar. */
  sinDatos?: boolean;
  nombre: string;
  onEditar: () => void;
}) {
  let resumen = '…';
  if (avisos) resumen = `${avisosEncendidos(avisos)} de ${TIPOS_AVISO.length}`;
  else if (sinDatos) resumen = 'Sin datos';
  return (
    <div className="resumen-correos">
      <span className="resumen-correos__cuenta">{resumen}</span>
      <button
        type="button"
        className="boton"
        aria-label={`Editar los correos de ${nombre}`}
        onClick={onEditar}
      >
        Editar
      </button>
    </div>
  );
}
